// extracted by mini-css-extract-plugin
module.exports = {"container":"Comic_container__3Xrlc","comic":"Comic_comic__2jTxw","copyright":"Comic_copyright__1604Z"};